export const ConnectionStatus = {
    Connected: 'Connected',
    Disconnected: 'Disconnected'
}